import { UserFREType } from "sh-models";
import { UserStore } from "sh-stores";

export function hasSeenFRE(freKey: UserFREType): boolean {
    const fresShownSoFar = UserStore().userSettings && UserStore().userSettings.fresShownSoFar;
    return !!(fresShownSoFar && fresShownSoFar.indexOf(freKey) !== -1);
}